import script from "./PerformerCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./PerformerCard.vue?vue&type=script&lang=ts&setup=true"

import "./PerformerCard.vue?vue&type=style&index=0&id=1d26236a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d26236a"]])

export default __exports__